export enum Designation {
  Staff = 2,
  Representative = 4,
  Other = 0,
}
